export default "__VITE_ASSET__D_eP0Goc__"